$("#s-HeaderMenu-shop-window2soul").mouseover(function(){
  $("#wds").addClass('test');
     $(".rmZ").css("z-index", "unset");
    $("#wds").css("z-index", "3");
});
$("#s-HeaderMenu-shop-shop-all").mouseover(function(){
     $(".rmZ").css("z-index", "unset");
    $("#spal").css("z-index", "3");
});

$("#s-HeaderMenu-shop-blooming-fire").mouseover(function(){
    $(".rmZ").css("z-index", "unset");
    $("#blm").css("z-index", "3");
});

$("#s-HeaderMenu-shop-saltedmuse").mouseover(function(){
    $(".rmZ").css("z-index", "unset");
    $("#saltedmuse").css("z-index", "3");
});

$(".header__menu-item").on( "mouseout", function() {
    $(".rmZ").css("z-index", "unset");
});

// DISCOVER PAGES

$("#s-HeaderMenu-shop-window2soul").mouseover(function(){
  $("#wds").addClass('test');
     $(".rmZ").css("z-index", "unset");
    $("#wds").css("z-index", "3");

});  
  
$(document).ready(function() {
    $("summary").click(function(){
        $(".header__inline-menu").addClass("openTheMenu");
    });

    //   $("#HeaderMenu-discover[aria-expanded='false']").click(function(){
    //     $(".header__inline-menu").addClass("openTheMenu");
    // });

    //   $("#Header-Search-m").click(function(){
    //     $(".header__inline-menu").addClass("openTheMenu");
    // });


    // Listen for click events on the document
    $(document).on("click", function(event) {
        // Check if the click target is not within the modal or the modal toggle button
        if (!$(event.target).closest(".header__inline-menu").length && !$(event.target).is("#HeaderMenu-shop")) {
            // Remove the class from the modal
            $(".header__inline-menu").removeClass("openTheMenu");
        }

        if (!$(event.target).closest(".header__inline-menu").length && !$(event.target).is("#HeaderMenu-discover")) {
            // Remove the class from the modal
            $(".header__inline-menu").removeClass("openTheMenu");
        }

        if (!$(event.target).closest(".header__inline-menu").length && !$(event.target).is("#HeaderMenu-discover")) {
            // Remove the class from the modal
            $(".header__inline-menu").removeClass("openTheMenu");
        }
    });
});

function removeGroupItems(groupId) {
    // Step 1: Fetch the current cart contents
    fetch(`${window.Shopify.routes.root}cart.js`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to fetch cart data.');
        }
        return response.json();
    })
    .then(cartData => {
        console.log('Current cart data:', cartData);

        // Step 2: Find items matching the provided _Group ID
        const itemsToRemove = cartData.items.filter(item => 
            item.properties && item.properties["_Group ID"] === groupId
        );

        if (!itemsToRemove.length) {
            console.warn(`No items found with _Group ID: ${groupId}`);
            return;
        }

        console.log('Items matching group:', itemsToRemove);

        // Prepare the updates object: set quantities of matching items to 0
        let updates = {};
        itemsToRemove.forEach(item => {
            updates[item.key] = 0; // Use item.key instead of item.id
        });

        console.log('Prepared updates:', updates);

        // Step 3: Send the cart update request
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        });
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to update the cart.');
        }
        return response.json().then(data => {
            console.log('Update response:', data);
            return data;
        });
    })
    .then(updatedCart => {
        console.log('Cart after update:', updatedCart);

        // Step 4: Check if the group was successfully removed
        const remainingGroupIds = new Set(
            updatedCart.items
                .map(item => item.properties && item.properties["_Group ID"])
                .filter(Boolean) // Remove null/undefined
        );

        if (!remainingGroupIds.has(groupId)) {
            console.log(`_Group ID ${groupId} is fully removed.`);
        } else {
            console.log(`_Group ID ${groupId} still exists in the cart.`);
        }

      
    })
      .then(data => {
    console.log('Products added to cart:', data);
    // Refresh cart contents
    fetch(`${window.Shopify.routes.root}cart.js`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(cartData => {
        console.log('Updated Cart Contents:', cartData);
        console.log("DATADADADADADADADADADA", cartData.item_count);
      var  itemsInCartNow = cartData.item_count
        $(".cart-count-bubble span").text(itemsInCartNow);
        if(cartData.item_count == 0 ){
          $("cart-drawer").addClass("is-empty");
  $(".drawer__inner-empty").css("display", "flex");
          $("cart-drawer-items").addClass("is-empty");
        }
        // Update total price
        const totalPriceCents = cartData.total_price;
        const totalPriceDollars = (totalPriceCents / 100).toFixed(2);
        const totalValueElement = document.querySelector('.totals__total-value');
        if (totalValueElement) {
          totalValueElement.textContent = `$${totalPriceDollars}`;
        }
        // Update cart drawer items
        const cartDrawerItems = document.querySelector('cart-drawer-items');
        if (cartDrawerItems) {
          // Fetch the updated HTML for cart drawer
          fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`)
            .then(response => response.text())
            .then(responseText => {
              const parser = new DOMParser();
              const html = parser.parseFromString(responseText, 'text/html');
              const updatedCartDrawer = html.querySelector('cart-drawer-items');
              if (updatedCartDrawer) {
                cartDrawerItems.innerHTML = updatedCartDrawer.innerHTML;
              }
            })
            .catch(error => console.error('Error updating cart drawer:', error));
        }
        // Update other cart sections as necessary
        const mainCartItems = document.querySelector('cart-items');
        if (mainCartItems) {
          fetch(`${window.Shopify.routes.root}cart?section_id=main-cart-items`)
            .then(response => response.text())
            .then(responseText => {
              const parser = new DOMParser();
              const html = parser.parseFromString(responseText, 'text/html');
              const updatedMainCart = html.querySelector('cart-items');
              if (updatedMainCart) {
                mainCartItems.innerHTML = updatedMainCart.innerHTML;
              }
            })
            .catch(error => console.error('Error updating main cart:', error));
        }
      })
      .catch(error => console.error('Error fetching updated cart:', error));
  })
    .catch(error => {
        console.error('Error while removing group items:', error);
    });
}  


var timer;

timer = setInterval(function() {
    if(document.querySelector("square-placement")) {

    var item = document.querySelector("square-placement");
    var afterPay = item.shadowRoot;

    var afterStyle = document.createElement("style");

    var afterStyleTxt = `
        .afterpay-paragraph * {
        font-family : "neue-haas-grotesk-display"; 
        font-weight : 450;
        color : #29201f;
        }

        .afterpay-paragraph strong {
        font-weight : 700;
        }

        @media (max-width : 768px)  {
        .afterpay-paragraph * {
            font-size : 12px!important;
        }

        .afterpay-logo-link .afterpay-logo {
            margin-bottom : 0!important;
        }
        
        .afterpay-logo-link .afterpay-logo svg {
            margin-left : -22px!important;
            height : 20px;
            width : 80px;
        }
        
        }
    `;
    afterStyle.innerHTML = afterStyleTxt;

    if(afterPay.querySelector(".afterpay-logo-link .afterpay-logo svg")) {

        console.log("afterPay", afterPay.querySelector(".afterpay-logo-link .afterpay-logo"));
        console.log("afterPay", afterPay.querySelector(".afterpay-logo-link .afterpay-logo svg path"));

        afterPay.querySelector(".afterpay-logo-link .afterpay-logo").style.overflow = "hidden";
        afterPay.querySelector(".afterpay-logo-link .afterpay-logo").style.width = "fit-content";
        afterPay.querySelector(".afterpay-logo-link .afterpay-logo").style.marginBottom = "4px";
        afterPay.querySelector(".afterpay-logo-link .afterpay-logo svg").style.marginLeft = "-25px";

        setTimeout(function() {
        afterPay.querySelector(".afterpay-logo-link .afterpay-logo").style.overflow = "hidden";
        afterPay.querySelector(".afterpay-logo-link .afterpay-logo").style.width = "fit-content";
        afterPay.querySelector(".afterpay-logo-link .afterpay-logo").style.marginBottom = "4px";
        afterPay.querySelector(".afterpay-logo-link .afterpay-logo svg").style.marginLeft = "-25px";
        }, 300);

        setTimeout(function() {
        afterPay.querySelector(".afterpay-logo-link .afterpay-logo").style.overflow = "hidden";
        afterPay.querySelector(".afterpay-logo-link .afterpay-logo").style.width = "fit-content";
        afterPay.querySelector(".afterpay-logo-link .afterpay-logo").style.marginBottom = "4px";
        afterPay.querySelector(".afterpay-logo-link .afterpay-logo svg").style.marginLeft = "-25px";
        // afterPay.querySelectorAll(".afterpay-logo-link .afterpay-logo svg path")[0].remove();
        // afterPay.querySelectorAll(".afterpay-logo-link .afterpay-logo svg path")[1].remove();
        afterPay.appendChild(afterStyle);
        item.classList.add("active");
        }, 1000);
        
        clearInterval(timer);
    }
    }
}, 1000);
